import React, { useEffect } from 'react';
import { Card, Col, Row } from 'antd';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import type { TableProps } from 'antd/es/table';

// Layout, Store, and Types Imports
import MainLayout from '../../../components/MainLayout/MainLayout';
import { DijikolayCustomer } from '../../../redux/reducers/dijikolay/dijikolay.types';

// Specific Redux Actions
import {
    fetchDijikolayCustomersRequest,
    setDijikolayFilters,
    updateDijikolayStatusRequest,
    updateDijikolayContactedRequest,
} from '../../../redux/reducers/dijikolay/dijikolaySlice';

// Child Component
import DijikolayTable from './components/DijikolayTable';

const Dijikolay = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation('dijikolay');

    useEffect(() => {
        dispatch(fetchDijikolayCustomersRequest());
    }, [dispatch]);


    const handleUpdateStatus = (id: number, status: string) => {
        dispatch(updateDijikolayStatusRequest({ id, status }));
    };

    const handleUpdateContacted = (id: number) => {
        dispatch(updateDijikolayContactedRequest({ id }));
    };

    const handleTableChange: TableProps<DijikolayCustomer>['onChange'] = (pagination, tableFilters, sorter) => {
        const status = tableFilters.status as string[] | null;
        const contactedValue = tableFilters.contacted ? (tableFilters.contacted[0] as string) : null;
        const contactedAsBoolean = contactedValue === 'true' ? true : (contactedValue === 'false' ? false : null);

        dispatch(setDijikolayFilters({ status, contacted: contactedAsBoolean }));
    };

    return (
        <MainLayout>
            <Row style={{ paddingBottom: 24 }} gutter={[24, 24]}>
                <Col xs={24}>
                    <Card
                        bodyStyle={{ padding: "0px", overflow: "visible", overflowX: "auto" }}
                        className="custom-card-head"
                        title={<span className='base-card-header-title'>{t('dijikolay_customers')}</span>}
                    >
                        <DijikolayTable
                            onUpdateStatus={handleUpdateStatus}
                            onUpdateContacted={handleUpdateContacted}
                            onChange={handleTableChange}
                        />
                    </Card>
                </Col>
            </Row>
        </MainLayout>
    );
};

export default Dijikolay;